
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M26.783 26.783a5.217 5.217 0 116.956 4.92A2.609 2.609 0 0032 34.163v1.75M32 41.13a.652.652 0 100 1.305.652.652 0 000-1.305h0"}}),_c('path',{attrs:{"d":"M12.435 32c0 10.806 8.76 19.565 19.565 19.565 10.806 0 19.565-8.76 19.565-19.565 0-10.806-8.76-19.565-19.565-19.565-10.806 0-19.565 8.76-19.565 19.565z"}})])])
          )
        }
      }
    